import React, { useState, useRef, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import * as API from "../../api";
import { Popup } from "../../ReusableComponents/reusableFunctions";

export default function KMLUploader({ projectId, onUploadComplete }) {
  const [show, setShow] = useState(false);
  const [progress, setProgress] = useState(0);
  const intervalRef = useRef(null);

  useEffect(() => {
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, []);

  const handleLabelClick = (e) => e.stopPropagation();

  const handleFileChange = async (e) => {
    e.stopPropagation();
    const file = e.target.files && e.target.files[0];
    if (!file) return;

    const fileName = file.name.toLowerCase();
    if (!fileName.endsWith(".kml")) {
      Popup.alert("error", "Please select a valid KML file!");
      return;
    }

    setShow(true);
    setProgress(0);

    const formData = new FormData();
    formData.append("kmlFile", file);
    formData.append("projectId", projectId);

    try {
      const session = await API.sessionCheck();
      const token = session.access_token;

      const xhr = new XMLHttpRequest();
      xhr.open(
        "POST",
        `${API.UPLOAD_PROJECT_KML}?projectId=${projectId}`,
        true
      );
      xhr.setRequestHeader("authorization", `Bearer ${token}`);

      xhr.upload.onprogress = (event) => {
        if (event.lengthComputable) {
          const percent = Math.round((event.loaded / event.total) * 100);
          setProgress(percent);
        }
      };

      xhr.onload = () => {
        if (xhr.status === 200) {
          const response = JSON.parse(xhr.responseText);
          setProgress(100);
          setTimeout(() => setShow(false), 500);
          if (onUploadComplete) onUploadComplete(projectId, file, response.url);
        } else {
          console.error("Upload failed:", xhr.responseText);
          Popup.alert("error", "KML upload failed!");
          setShow(false);
        }
      };

      xhr.onerror = () => {
        console.error("Upload error:", xhr.responseText);
        Popup.alert("error", "KML upload failed!");
        setShow(false);
      };

      xhr.send(formData);
    } catch (err) {
      console.error("Upload exception:", err);
      setShow(false);
    }
  };



  const handleCancel = () => {
    if (intervalRef.current) clearInterval(intervalRef.current);
    setShow(false);
    setProgress(0);
  };

  return (
    <>
      <label
        style={{
          color: "blue",
          cursor: "pointer",
          fontSize: "12px",
          textDecoration: "underline",
          display: "inline-block",
        }}
        onClick={handleLabelClick}
      >
        Upload
        <input
          type="file"
          accept=".kml"
          style={{ display: "none" }}
          onChange={handleFileChange}
        />
      </label>

      <Modal
        show={show}
        onHide={handleCancel}
        className="modal-dialog-centered"
        centered
      >
        <Modal.Body style={{ textAlign: "center", padding: "24px" }}>
          <h5 style={{ marginBottom: 12 }}>
            {progress === 100 ? "Upload Completed!" : "Uploading KML..."}
          </h5>
          <div style={{ width: 160, height: 160, margin: "8px auto" }}>
            <CircularProgressbar value={progress} text={`${progress}%`} />
          </div>
        </Modal.Body>
        <Modal.Footer style={{ justifyContent: "center" }}>
          {progress === 100 ? 
          <button className="btn btn-secondary" onClick={handleCancel}>
            {progress < 100 ? null : "Close"}
          </button> : null
}
        </Modal.Footer>
      </Modal>
    </>
  );
}
